import { Row, Col } from "antd";
import React from "react";
import Typing from "react-typing-effect";
import PageBackground from "../components/PageBackground";

const AboutMe = () => {
  return (
    <div className="relative min-h-[calc(100vh-4rem)] w-full">
      <PageBackground subtle />
      <div className="page-shell relative z-10 mx-auto flex max-w-7xl items-center py-10 md:py-14">
        <Row
          gutter={[32, 32]}
          className="w-full items-center justify-center p-2 md:p-6"
        >
          <Col xs={24} md={9} className="flex flex-col items-center">
            <Typing
              className="mb-6 font-mono text-3xl font-medium text-brand-600 dark:text-brand-400 md:text-4xl"
              text={["$ whoami"]}
              typingDelay={1350}
              speed={50}
              eraseDelay={5000000}
              cursorClassName="text-brand-400"
            />
            <div className="photo-ring">
              <div className="photo-ring-inner">
                <img
                  src="/images/imageofmetwo.jpg"
                  alt="Julian Boyko"
                  className="h-56 w-56 rounded-full object-cover sm:h-64 sm:w-64 md:h-72 md:w-72"
                />
              </div>
            </div>
          </Col>

          <Col xs={24} md={15}>
            <div className="space-y-4 text-base leading-relaxed text-ink-600 dark:text-ink-300 md:text-lg">
              <p>
                Hi! I'm{" "}
                <span className="font-semibold text-ink-900 dark:text-ink-100">
                  Julian Boyko
                </span>
                , a Software Engineer based in Vancouver, Canada. I have a
                background in Software Development and Computer Science & began
                programming at the age of 12 with Java and haven't stopped since!
              </p>
              <p>
                Personally, I've developed mobile applications released on the App
                Store, web applications, and video game servers (including
                deployment and development). Professionally, I've developed
                numerous features and functionalities used by millions, achieved
                through designing complex systems and architecture.
              </p>
              <p>
                Outside of work, I'm either trying a new restaurant, finding a new
                trail to hike, or tapping out (and occasionally not tapping out) in
                Brazilian Jiu-Jitsu.
              </p>
              <p>
                I'm passionate about continuing to build impactful software
                solutions and continuously learning new things.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AboutMe;
